// 优惠券
const user = () => import('@/components/foot/user.vue');
const aboutUs = () => import('@/components/foot/aboutUs.vue');
const contactUs = () => import('@/components/foot/contactUs.vue');

export default [
  {
    path: '/user',
    component: user,
    meta: {
      title: '用户协议',
    },
  },
  {
    path: '/aboutUs',
    component: aboutUs,
    meta: {
      title: '关于我们',
    },
  },
  {
    path: '/contactUs',
    component: contactUs,
    meta: {
      title: '联系我们',
    },
  },
];
